<template>
  <div class="my-card">
    <b-button
      variant="primary"
      :to="{name: 'master-product-add'}"
    >
      Tambah Produk
    </b-button>
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :select-options="{
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Harga Modal -->
        <span v-if="props.column.field === 'price'">
          <b-button
            v-b-modal.modal-price
            variant="outline-primary"
            @click="openPriceModal(props.row['prices'])"
          >
            Lihat Harga
          </b-button>
        </span>

        <!-- Column: Status -->
        <span v-else-if="props.column.field === 'status'">
          <b-badge :variant="statusVariant(props.row.status)">
            {{ props.row.status }}
          </b-badge>
        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item :to="{ name: 'master-product-edit', params: {id: props.row.id} }">
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Edit</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Showing 1 to
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3','5','10']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
    <!-- modal price -->
    <b-modal
      id="modal-price"
      v-model="showPriceModal"
      ok-only
      ok-title="Tutup"
      centered
      size="lg"
      title="Harga Produk"
    >
      <b-card-body>
        <b-table
          responsive="sm"
          :items="selectedPrice"
        />
      </b-card-body>
    </b-modal>
  </div>
</template>

<script>
import {
  BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem,
  BButton, BTable, BCardBody, BModal,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'

export default {
  components: {
    VueGoodTable,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton,
    BTable,
    BCardBody,
    BModal,
  },
  data() {
    return {
      selectedPrice: [],
      showPriceModal: false,
      pageLength: 10,
      dir: false,
      columns: [
        { field: 'sku', label: 'SKU' },
        { field: 'name', label: 'Produk' },
        { field: 'unit', label: 'Unit' },
        { field: 'category', label: 'Kategori' },
        { field: 'price', label: 'Harga' },
        { field: 'updated_at', label: 'Diperbarui Pada' },
        { field: 'status', label: 'Status' },
        { field: 'action', label: 'Action' },
      ],
      rows: [],
      searchTerm: '',
      status: {
        1: 'Aktif',
        0: 'Nonaktif',
        3: 'Stok Habis',
      },
      products: [],
    }
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Aktif: 'light-success',
        Nonaktif: 'light-danger',
        'Stok Habis': 'light-warning',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  created() {
    this.$http.get('/product')
      .then(res => {
        this.products = res.data
        this.rows = res.data.map(product => {
          const modifiedAt = new Date(product.updated_at).toLocaleString('id-ID', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
            timeZone: 'UTC',
          }).replace('.', ':')
          return {
            id: product.id,
            sku: product.sku,
            prices: product.prices,
            name: product.name,
            unit: product.unit ? product.unit.name : null,
            category: product.category ? product.category.name : null,
            updated_at: modifiedAt,
            status: this.status[product.status],
          }
        })
      })
  },
  methods: {
    openPriceModal(prices) {
      this.selectedPrice = prices.map(price => ({
        member: price.member_status === 1 ? 'Member' : 'Umum',
        harga: `Rp${this.formatPrice(price.price)}`,
        minPenjualan: price.min_sales,
      }))
      this.showPriceModal = true
    },
    formatPrice(price) {
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
